import { render } from "./DesignSamplesProjectWatch.vue?vue&type=template&id=446412ba"
import script from "./DesignSamplesProjectWatch.vue?vue&type=script&lang=js"
export * from "./DesignSamplesProjectWatch.vue?vue&type=script&lang=js"

import "./DesignSamplesProjectWatch.vue?vue&type=style&index=0&id=446412ba&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__